module.exports = __webpack_public_path__ + "bin/d98919f724ebd402a9d6a7854b39d5fd.jpg";